const images = {
    agadir: require('./agadir.png'),
    casa: require('./casa.png'),
    paris: require('./paris.png'),
    lyon: require('./lyon.png'),
    lausanne: require('./lausanne.jpg'),
};
    
export default images;